export default theme => ({
  alert: {
    background: theme.palette.userSecondary.main,
    "& *": {
      color: theme.palette.white.main,
      fontWeight: 500,
    },
    "&:hover *": {
      color: theme.palette.userPrimary.main,
      fontWeight: "unset",
    },
  },
  alertText: {
    textTransform: "uppercase",
    fontSize: 15,
  },
});
